import HoverTooltip from 'components/common/HoverTooltip';
import axios from 'helpers/axios';
import config from 'helpers/config';
import { ChevronDown } from 'lucide-react';
import WorkflowStatus from 'models/WorkflowStatusModel';
import React, { useEffect, useState } from 'react';

interface Props {
    status: number;
    workflowStatusId: string;
    updateOrderStatus: (status: number) => void;
    updateWorkflowStatus: (workflowStatusId: string) => void;
}

const RepairOrderStatus: React.FC<Props> = (props: Props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isWorkflowDropdownExpanded, setIsWorkflowDropdownExpanded] = useState(false);
    const [workflowStatuses, setWorkflowStatuses] = useState<WorkflowStatus[]>([]);

    useEffect(() => {
        axios
            .get(`${config.apiUrl}/tenant/workflowStatuses`)
            .then((res) => {
                setIsLoading(false);
                setWorkflowStatuses(res.data);
            })
            .catch((err) => console.log(err));
    }, []);

    // handlePostRepairOrder = () => {
    //     axios
    //         .post(`${config.apiUrl}/repairOrders/${props.id}/post`)
    //         .then((res) => {
    //             console.log(res);
    //         })
    //         .catch((err) => console.log(err));
    // }

    return (
        <>
            <div className="space-y-4">
                <div className="flex space-x-2">
                    <HoverTooltip content="Set as Estimate">
                        <button
                            onClick={() => props.updateOrderStatus(0)}
                            className={`px-4 py-2 rounded-md font-semibold border ${
                                props.status === 0
                                    ? 'bg-blue-100 text-blue-800 border-blue-200'
                                    : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-300'
                            } `}
                        >
                            ESTIMATE
                        </button>
                    </HoverTooltip>
                    <HoverTooltip content="Set as Invoice">
                        <button
                            onClick={() => props.updateOrderStatus(1)}
                            className={`px-4 py-2 rounded-md font-semibold border
                                ${
                                    props.status === 1
                                        ? 'bg-green-100 text-green-800 border-green-200'
                                        : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-300'
                                }`}
                        >
                            INVOICE
                        </button>
                    </HoverTooltip>
                </div>

                {!isLoading && (
                    <div className="border-t border-gray-200 pt-4 pb-2">
                        <h4 className="font-semibold mb-2">Workflow</h4>
                        <div className="flex flex-col space-y-3">
                            <div className="relative">
                                <select
                                    value={props.workflowStatusId}
                                    onChange={(e) => props.updateWorkflowStatus(e.target.value)}
                                    className="w-full p-2 pr-10 bg-white border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                >
                                    {workflowStatuses.map((status) => (
                                        <option
                                            key={status.id}
                                            value={status.id}
                                            selected={status.id === props.workflowStatusId}
                                        >
                                            {status.name}
                                        </option>
                                    ))}
                                </select>
                                <ChevronDown className="absolute right-3 top-2.5 w-5 h-5 text-gray-400 pointer-events-none" />
                            </div>

                            <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md font-semibold transition-colors">
                                Post Repair Order
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default RepairOrderStatus;
